<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<coso-replicator-page-header [title]="'User Mapping'"></coso-replicator-page-header>
@if (isSaaS === false && isFailoverBackupInstance) {
<alert type="warning">
  <coso-alert-message> This configuration is taken automatically from main instance, and therefore is read-only.</coso-alert-message>
</alert>
} @if (isSaaS === false && isRunning) {
<alert type="warning">
  <coso-alert-message>You can only modify the content of this page once the replication process is stopped.</coso-alert-message>
</alert>
} @if (licenseInfo) {
<alert [type]="licenseInfo.usersOverLimitCurrentTenant > 0 ? 'warning' : 'info'" [dismissible]="false">
  <coso-alert-message>
    {{
      licenseInfo.usersOverLimitCurrentTenant > 0
        ? 'You have exceeded the maximum number of users allowed for your license (' + licenseInfo.usersOverLimitCurrentTenant + ' user(s) are over limit).'
        : 'You have currently ' +
          (licenseInfo.inUseCurrentTenant ? licenseInfo.inUseCurrentTenant : numberOfMappedUsers) +
          ' user(s) mapped' +
          (licenseInfo.maximumUsers ? ' in a total of ' + licenseInfo.maximumUsers + ' users allowed for your license.' : '.')
    }}
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}

<div class="d-lg-flex justify-content-between mb-3">
  <div class="btn-group dropdown justify-content-lg-start" placement="bottom right">
    <button
      id="btnExportDropdownMenu"
      type="button"
      class="btn btn-primary dropdown-toggle mr-2"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      aria-controls="btnExportDropdownMenu"
      aria-label="Open Export options. Press ESC to close the dropdown."
    >
      <span class="fa fa-fw fa-download mr-1" aria-hidden="true"></span>Export
    </button>
    <div class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="dropdownMenu">
      <button
        role="menuitem"
        class="dropdown-item"
        placement="top"
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Export user mapping in CSV format"
        (click)="exportUserMappingToCsv()"
      >
        <span class="fa fa-fw fa-file-o mr-1" aria-hidden="true"></span>Export to CSV
      </button>
      <button
        role="menuitem"
        class="dropdown-item"
        placement="top"
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Export user mapping in JSON format"
        (click)="exportUserMappingToJson()"
      >
        <span class="fa fa-fw fa-file-o mr-1" aria-hidden="true"></span>Export to JSON
      </button>
      <button
        role="menuitem"
        class="dropdown-item"
        placement="top"
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Export user mapping in XML format"
        (click)="exportUserMappingToXml()"
      >
        <span class="fa fa-fw fa-file-o mr-1" aria-hidden="true"></span>Export to XML
      </button>
    </div>
  </div>
  <button
    id="settingsLauncherButton"
    class="btn btn-primary"
    (click)="openSettingsModal()"
    placement="right"
    data-toggle="tooltip"
    data-placement="top"
    data-original-title="Configure user mapping settings"
  >
    <span class="fa fa-cog mr-1" aria-hidden="true"></span>Settings
  </button>
</div>

@if ({ isLoading: loadingService.isAnySpinnerActive$ | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-grid [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowData]="rowData" [recordsTotal]="rowData.length" [searchable]="true" [paginationPageSizeOptions]="[50, 100, 500, 1000]">
  <div class="btn-group-sm" topBarLeft>
    <button
      class="btn btn-secondary mr-2"
      placement="top"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Block selected automated user mapping"
      (click)="blockSelected()"
      [disabled]="isReadOnly || !isBlockAllowed"
    >
      <span class="fa fa-minus-circle mr-1" aria-hidden="true"></span>Block selected
    </button>
    <button
      class="btn btn-secondary mr-2"
      placement="top"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Unblock selected user mapping"
      (click)="removeSelected()"
      [disabled]="isReadOnly || !isUnblockAllowed"
    >
      <span class="fa fa-check-circle mr-1" aria-hidden="true"></span>Unblock selected
    </button>
    <button
      class="btn btn-danger mr-2"
      placement="top"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Remove selected custom user mapping"
      (click)="removeSelected()"
      [disabled]="isReadOnly || !isRemoveAllowed"
    >
      <span class="fa fa-trash mr-1" aria-hidden="true"></span>Remove selected
    </button>
  </div>
</coso-grid>
<a class="btn btn-dark mt-5" [routerLink]="['/', 'configuration', instanceId, 'connections']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Connections list</a>
} }

<ng-template #actionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm">
    <button
      id="editActionButton#{{ params.node.rowIndex }}"
      class="btn btn-dark"
      data-toggle="tooltip"
      title="Edit user mapping"
      [disabled]="isReadOnly || params.data.mappingStatus == MappingStatus.Blocked || currentSettings.groupStorage !== GroupStorage.SharePoint"
      (click)="openEditModal(params)"
      [attr.aria-label]="
        params.data.loginInfo.loginName ? 'Edit mapping between Dynamics 365 ' + params.data.name + ' and SharePoint ' + params.data.loginInfo.name : 'Create mapping for ' + params.data.name
      "
    >
      <span class="fa fa-pencil" aria-hidden="true"></span>
    </button>
  </div>
</ng-template>
